<script lang="ts">
  import Footer from './footer.svelte'
  import Header from './header.svelte'

  import type { LayoutProps } from './index-layout.types'

  const { children, headerIsActive }: LayoutProps = $props()
</script>

<Header {headerIsActive} />

{@render children()}

<Footer />
